// src/components/Filter/DateRangeFilter.tsx
import React, { useEffect, useState } from "react";
import moment from "moment";
import "./DateRangeFilter.css";

type Props = {
  startDate: string; // 'YYYY-MM-DDTHH:mm:ss'
  endDate: string;
  onApply: (start: string, end: string) => void;
  onClear: () => void;
};

const DateRangeFilter: React.FC<Props> = ({ startDate, endDate, onApply, onClear }) => {
  const formatForInput = (s?: string) => (s ? moment(s).format("YYYY-MM-DDTHH:mm") : "");
  const toStoreFormat = (inputVal: string) =>
    inputVal ? moment(inputVal).format("YYYY-MM-DDTHH:mm:ss") : "";

  const [localStart, setLocalStart] = useState<string>(formatForInput(startDate));
  const [localEnd, setLocalEnd] = useState<string>(formatForInput(endDate));

  useEffect(() => {
    setLocalStart(formatForInput(startDate));
    setLocalEnd(formatForInput(endDate));
  }, [startDate, endDate]);

  return (
    <div className="date-range-filter-container">
      <small className="text-muted d-block mb-2">
        Use the date range picker to change the data shown on the charts
      </small>

      <div className="date-range-filter">
        <div>
          <label>From</label>
          <input
            type="datetime-local"
            value={localStart}
            onChange={(e) => {
              const newStart = e.target.value;
              if (!localEnd || newStart <= localEnd) {
                setLocalStart(newStart);
              } else {
                alert("Start date cannot be later than end date");
              }
            }}
          />
        </div>

        <div>
          <label>To</label>
          <input
            type="datetime-local"
            value={localEnd}
            onChange={(e) => {
              const newEnd = e.target.value;
              if (!localStart || newEnd >= localStart) {
                setLocalEnd(newEnd);
              } else {
                alert("End date cannot be earlier than start date");
              }
            }}
          />
        </div>

        <div>
          <button
            className="btn-apply"
            onClick={() => onApply(toStoreFormat(localStart), toStoreFormat(localEnd))}
          >
            Apply
          </button>
          <button
            className="btn-clear"
            onClick={() => {
              setLocalStart("");
              setLocalEnd("");
              onClear();
            }}
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default DateRangeFilter;
